import { createContext } from 'react'

import type { WinninAIReport, WinninAIReportContextData } from './types'

export const WinninAIReportContext = createContext<WinninAIReportContextData>({
  winninAIReport: {} as WinninAIReport,
  addWinninAIReportItem: (_id, _entity, _providers, _name) => {},
  addWinninAIReportDetails: () => {},
  resetWinninAIReport: () => {},
  backToPreviousStep: () => {},
})
